import React, { useEffect, useState } from "react";
import { useParams } from "react-router";
import Navbar from "../../components/ui/Navbar";
import styles from "./History.module.css";
import Footer from "../../components/ui/Footer";
import FixedAgent from "../../utils/api/FixedAgent";
import { useSelector } from "react-redux";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Menu from "../../components/ui/Menu";

function OrderDetails(props) {
  const [products, setProducts] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [historyLength, setHistoryLength] = useState(0);
  const { id } = useParams();
  const token = useSelector((state) => state.userData.loginData.token);

  const user = useSelector((state) => state.userData.personalInfo);

  // const accountType = useSelector(
  //   (state) => state.userData.loginData.account_type
  // );
  // const navigate = useNavigate();
  const url = process.env.REACT_APP__BASE_URL;

  const closeMenuHandler = () => {
    props.setShowMenu(false);
  };

  useEffect(() => {
    if (historyLength % 30 === 0 && historyLength !== 0) {
      FixedAgent.sendTicket({
        to_name: "Admin",
        from_name: `${user.fullname} (${user.email})`,
        message: `Congratulations! ${user.fullname} (${user.email}) has successfully processed 30 orders and has won a FREE PIN!`,
      });
    }
  }, [historyLength, user.fullname, user.email]);

  useEffect(() => {
    const fetchHistoryList = async () => {
      try {
        const historyListRes = await FixedAgent.getManualOrderHistory({
          token,
        });
        setHistoryLength(historyListRes.data.data.length);
      } catch (err) {
        toast.error(err?.response?.data?.message, {
          position: "top-left",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        });
      }
    };
    fetchHistoryList();
  }, [token]);

  useEffect(() => {
    const fetchOrderDetails = async () => {
      try {
        const orderRes = await FixedAgent.getManualOrderDetails({
          id,
          token,
        });
        setProducts(orderRes.data);
      } catch (err) {
        setIsLoading(false);
        toast.error(err?.response?.data?.message, {
          position: "top-left",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        });
      }
    };
    fetchOrderDetails();
  }, [id, token]);

  return (
    <div>
      <ToastContainer />
      <div className="menu" onClick={closeMenuHandler}>
        {props.showMenu && <Menu setShowMenu={props.setShowMenu} />}
      </div>
      <Navbar title="Order Details" setShowMenu={props.setShowMenu} />
      <div className={styles.body}>
        <div
          style={{ display: "flex", flexDirection: "column" }}
          className={styles.body_header}
        >
          <h1>
            Total: NGN
            {products?.order?.length >= 0
              ? products.order?.length > 0
                ? Number(products.order[0].amount).toLocaleString()
                : "0"
              : "0"}
          </h1>

          <h1>
            Plate Number:{" "}
            {products?.order?.length > 0
              ? products.order[0].plate_details.plate_no
              : "N/A"}
          </h1>
          <div className={styles.cards_wrapper}>
            {products?.details?.map((product, index) => (
              <div className={styles.card} key={product?.product_id}>
                <h1 className={styles.card_title}>
                  {product?.product_details?.product_name}
                </h1>
                <p className={styles.card_description}>
                  {product?.product_details?.product_category}
                  <span>{product?.product_details?.product_type}</span>
                </p>
                {/* <span className={styles.card_amount}>
                  NGN {Number(product?.price)?.toLocaleString()}
                </span> */}

                <button
                  disabled={!product?.file_link && !product?.headless}
                  onClick={() =>
                    window.open(
                      product?.file_link ||
                        (product?.headless?.platform?.toLowerCase() === "cei"
                          ? `https://certs.ceiil.com.ng/Certificate/GetPlainPolicyDocumentByRegistrationNumber/${products?.order[0]?.plate_details?.plate_no}`
                          : product?.headless?.platform?.toLowerCase() ===
                            "nicon"
                          ? `${url}/app/fixedagent/customer/order/nicon/cert/${products?.order[0]?.plate_details?.plate_no}`
                          : product?.headless?.platform?.toLowerCase() === "iei"
                          ? `${url}/app/fixedagent/customer/order/ieiplc/download/${products?.order[0]?.plate_details?.plate_no}`
                          : ""),
                      "_blank"
                    )
                  }
                  className={styles.card_button}
                >
                  Download Plain Policy
                </button>

                {product?.headless?.platform?.toLowerCase() === "cei" && (
                  <button
                    onClick={() =>
                      window.open(
                        `https://certs.ceiil.com.ng/Certificate/GetPrePrintedPolicyDocumentByRegistrationNumber/${products?.order[0]?.plate_details?.plate_no}`,
                        "_blank"
                      )
                    }
                    className={styles.card_button}
                  >
                    Download Pdf Policy
                  </button>
                )}
                {/* {accountType !== "DISTRIBUTOR" &&
                  product?.headless?.platform?.toLowerCase() === "cei" && (
                    <p
                      onClick={() =>
                        navigate(
                          `/edit-order/${product?.headless?.manual_unique_id}`
                        )
                      }
                      style={{ cursor: "pointer", color: "blue" }}
                    >
                      Edit this order
                    </p>
                  )} */}
              </div>
            ))}

            {isLoading &&
              [...Array(3)].map((_, index) => (
                <div key={index}>
                  <div className={`${styles.card} ${styles.skeleton}`}></div>
                </div>
              ))}
          </div>
          <div
            className={styles.card}
            style={{
              textAlign: "center",
              borderRadius: "8px",
              display: "flex",
              flexDirection: "column",
              backgroundColor: "#FFFFFF",
              boxShadow: "0px 4px 4px 0px #00000040",
              height: "304px",
              gap: "20px",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <p
              style={{
                fontFamily: "Circular Std",
                fontWeight: "700",
                fontSize: "18px",
                lineHeight: "100%",
                color: "black",
                letterSpacing: "0px",
                textAlign: "center",
              }}
            >
              {(() => {
                if (historyLength % 30 === 0 && historyLength !== 0) {
                  return "Congratulations";
                } else if (
                  historyLength % 30 >= 25 &&
                  historyLength % 30 < 30 &&
                  historyLength !== 0
                ) {
                  return "Almost!";
                } else {
                  return "Well done!";
                }
              })()}
            </p>
            <img
              src={(() => {
                if (historyLength % 30 === 0 && historyLength !== 0) {
                  return require("../../assets/image 82.png");
                } else if (
                  historyLength % 30 >= 25 &&
                  historyLength % 30 < 30 &&
                  historyLength !== 0
                ) {
                  return require("../../assets/image 84.png");
                } else {
                  return require("../../assets/image 83.png");
                }
              })()}
              alt="Dynamic"
              style={{ height: "131px", width: "50%", objectFit: "contain" }}
            />
            <p
              style={{
                fontFamily: "Circular Std",
                fontWeight: "700",
                color: "black",
                fontSize: "18px",
                lineHeight: "100%",
                letterSpacing: "0px",
                textAlign: "center",
              }}
            >
              {(() => {
                if (historyLength % 30 === 0 && historyLength !== 0) {
                  return "Congratulations! You have won a FREE PIN.";
                } else if (
                  historyLength % 30 >= 25 &&
                  historyLength % 30 < 30 &&
                  historyLength !== 0
                ) {
                  return `${30 - (historyLength % 30)} more to get a FREE PIN.`;
                } else {
                  return `Renew ${
                    30 - (historyLength % 30)
                  } more to get a FREE PIN.`;
                }
              })()}
            </p>
            <p
              style={{
                fontFamily: "Circular Std",
                fontWeight: "700",
                color: "black",
                fontSize: "12px", // Made text smaller
                lineHeight: "100%",
                letterSpacing: "0px",
                textAlign: "center", // Aligned text to the right
              }}
            >
              PS: This applies to only NICON. Also, you are eligible to 2 free
              pins only.
            </p>
          </div>
        </div>{" "}
      </div>

      <Footer />
    </div>
  );
}

export default OrderDetails;
